module.exports = __webpack_public_path__ + "legal.png?7a801a41caa81f793e7b7b41487ecaa3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/legal.png
// module id = 12
// module chunks = 0